import { HttpClient, httpResource } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DeletePassKeyRequestDTO, PassKeyDTO, GetProfileResponseDTO } from '../../../shared/models/generated';

@Service()
export class ProfileService {
    readonly http = inject(HttpClient);
    changePassword(currentPassword: string, newPassword: string) {
        return this.http.post(`${environment.apiUrl}/api/profile/change-password`, { currentPassword, newPassword });
    }
    deletePassKey(credentialId: string) {
        const body: DeletePassKeyRequestDTO = { credentialId };
        return this.http.post( `${environment.apiUrl}/api/profile/passkeys/delete`,  body );
    }
    resources = {
        getPassKeys: () => httpResource<PassKeyDTO[]>(() => ({ url: `${environment.apiUrl}/api/profile/passkeys` })),
        getProfile: () => httpResource<GetProfileResponseDTO>(() => ({ url: `${environment.apiUrl}/api/profile` }))
    }
}
